export default "__VITE_ASSET__C7GVwZ_C__"